import { render, staticRenderFns } from "./EditRoom.vue?vue&type=template&id=47c6cdb9&scoped=true"
import script from "./EditRoom.vue?vue&type=script&lang=js"
export * from "./EditRoom.vue?vue&type=script&lang=js"
import style0 from "./EditRoom.vue?vue&type=style&index=0&id=47c6cdb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6cdb9",
  null
  
)

export default component.exports